<script lang="ts">
	export let qnNumber: string;
	import QnComponent from './QnComponent.svelte';
	import {uqn} from './stores.js';
	//import getRandomInt from './functions/getRandomInt'
	//import Button, {Label} from '@smui/button';
	//import random from './check_random/random';
	//import FormField from '@smui/form-field';
	//import Checkbox from '@smui/checkbox';
	//import Katex from './Katex.svelte'
</script>

<h2>Question {qnNumber}</h2>
<QnComponent uqn={$uqn}/>
<hr>
